// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
img {
  display: block;
  max-inline-size: 100%;
}

hr {
  border-style: solid;
  border-color: var(--theme-secondary-text-color);
}

.material-symbols-outlined {
  font-variation-settings:
  'FILL' 0,
  'wght' 400,
  'GRAD' 0,
  'opsz' 24;
  text-orientation: upright;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  max-inline-size: 100%;
  box-sizing: border-box;
}

table :is(td, th) {
  border: solid .125rem var(--theme-disabled-text-color);
  padding-inline: .5em;
  padding-block: .25em;
  overflow-inline: auto;
  overflow-wrap: break-word;
}

blockquote {
  padding-inline: 1em;
  padding-block: .25em;
  margin-inline: .5em;
  border-inline-start: solid .125rem var(--theme-accent-color);
}

code, pre {
  font-family: ui-monospace, monospace;
}
`, "",{"version":3,"sources":["webpack://./src/common.css"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE;;;;WAIS;EACT,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sDAAsD;EACtD,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,4DAA4D;AAC9D;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["\nimg {\n  display: block;\n  max-inline-size: 100%;\n}\n\nhr {\n  border-style: solid;\n  border-color: var(--theme-secondary-text-color);\n}\n\n.material-symbols-outlined {\n  font-variation-settings:\n  'FILL' 0,\n  'wght' 400,\n  'GRAD' 0,\n  'opsz' 24;\n  text-orientation: upright;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n  max-inline-size: 100%;\n  box-sizing: border-box;\n}\n\ntable :is(td, th) {\n  border: solid .125rem var(--theme-disabled-text-color);\n  padding-inline: .5em;\n  padding-block: .25em;\n  overflow-inline: auto;\n  overflow-wrap: break-word;\n}\n\nblockquote {\n  padding-inline: 1em;\n  padding-block: .25em;\n  margin-inline: .5em;\n  border-inline-start: solid .125rem var(--theme-accent-color);\n}\n\ncode, pre {\n  font-family: ui-monospace, monospace;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
